function normalizedBasePath(value: string): string {
  if (!value || value === '/') return '/';
  const withLeadingSlash = value.startsWith('/') ? value : `/${value}`;
  return `${withLeadingSlash.replace(/\/+$/u, '')}/`;
}

// Vite replaces BASE_URL at build time. Keeping this value in the app shell
// makes BrowserRouter and links follow the same path as emitted assets.
export const CPQ_SHELL_BASE_PATH = normalizedBasePath(
  import.meta.env?.BASE_URL ?? '/',
);

export const CPQ_SHELL_REFRESH_FALLBACK = {
  source: '/*',
  destination: '/index.html',
  excludedPrefixes: ['/api/', '/assets/', '/cpq-v2/', '/cpq-next/'],
} as const;

function withoutTrailingSlash(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

export function assertCpqShellBase(baseUrl: string): void {
  if (baseUrl !== CPQ_SHELL_BASE_PATH) {
    throw new Error(
      `CPQ Vite base 不一致：期望 ${CPQ_SHELL_BASE_PATH}，实际 ${baseUrl}`,
    );
  }
}

export type CpqEntryOwner = 'vite-candidate' | 'outside-cpq';

export function classifyCpqEntry(pathname: string): CpqEntryOwner {
  const normalized = withoutTrailingSlash(pathname);
  const excludedPaths = ['/api', '/assets', '/cpq-v2', '/cpq-next'];
  return excludedPaths.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
  )
    ? 'outside-cpq'
    : 'vite-candidate';
}

export function routerBasename(): string {
  return withoutTrailingSlash(CPQ_SHELL_BASE_PATH);
}
